export function Insights() {
  return (
    <section id="insights" className="py-24 lg:py-32 bg-card border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-px bg-primary" />
            <span className="text-xs tracking-[0.3em] uppercase text-muted-foreground font-medium">
              Insights
            </span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6">
            Perspectives on risk
          </h2>
        </div>

        {/* Featured article */}
        <article className="max-w-4xl">
          <header className="mb-8">
            <span className="text-xs tracking-widest uppercase text-muted-foreground block mb-4">
              Featured
            </span>
            <h3 className="font-serif text-2xl lg:text-3xl text-foreground leading-tight mb-4">
              Why Cyber Risk Is a Boardroom Issue, Not an IT Problem
            </h3>
          </header>

          <div className="prose prose-invert prose-sm max-w-none">
            <p className="text-muted-foreground leading-relaxed mb-6">
              Cyber risk is still too often viewed as a technical issue, delegated to IT teams
              and discussed only after something goes wrong.
            </p>

            <p className="text-muted-foreground leading-relaxed mb-6">
              In reality, cyber incidents rarely fail because of technology alone. They fail
              because of decision-making, governance, communication and preparedness.
            </p>

            <p className="text-muted-foreground leading-relaxed mb-6">
              From my experience leading national cyber programmes and serious investigations,
              the organisations that recover fastest are not those with the most expensive
              tools. They are those with clear accountability, rehearsed response and senior ownership.
            </p>

            <p className="text-muted-foreground leading-relaxed mb-6">
              Boards don&apos;t need to understand firewalls or malware. They do need to understand
              risk appetite, business impact and resilience.
            </p>

            <p className="text-foreground leading-relaxed font-medium">
              Cyber is fundamentally a leadership issue. Treating it as anything else leaves
              organisations exposed not just to attack, but to reputational and operational failure.
            </p>
          </div>

          <footer className="mt-12 pt-8 border-t border-border/30">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 border border-primary/60 flex items-center justify-center">
                <span className="font-serif text-primary text-sm font-medium">NB</span>
              </div>
              <div>
                <span className="block text-sm text-foreground font-medium">Nick Bell</span>
                <span className="block text-xs text-muted-foreground">Cyber Risk Solutions</span>
              </div>
            </div>
          </footer>
        </article>
      </div>
    </section>
  )
}
